<template lang="pug">
  footer
    .social-wrap
      .social.container.mx-auto
        h3.title Folgen Sie uns!
        CDUCustomers(type="footerSocial")
    .footer-main-wrap
      .footer-main.container.mx-auto
        .grid-box
          .box.box-1
            h3 Navigation
            Menu.footer-menu#footer-menu-info(k="footer-menu-info" :max-depth="1")
          .box.box-2
            h3 Postadresse
            CDUCustomers(type="footerAddress")
          .box.box-3
            h3 Webtipps
            Menu.footer-menu#footer-menu-webtips(k="footer-menu-webtips" :max-depth="1")
    .copyright 
      .container.mx-auto
        p &copy; {{ new Date().getFullYear() }} {{ cms.name }}

</template>

<script>
import { mapGetters } from 'vuex';
import Menu from '@/components/Menu.vue';
import CDUCustomers from '@/components/CDUCustomers.vue';

export default {
    name: 'Footer',
    components: {
        Menu,
        CDUCustomers
    },
    computed: {
      address() {
        return this.cms.address;
      },

      ...mapGetters({
          cms: 'CMS',
          menus: 'menus',
          config: 'config'
      })
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

footer
  @apply block bottom-0 w-full
  .social-wrap
    background-color: $color-primary
    .social
      @apply flex justify-between items-center py-4 text-white
      min-height: 72px
      .title
        @apply font-bold
        font-size: 20px

  .footer-main-wrap
    @apply relative py-8
    @screen sm
      @apply py-12
    background-image: url('~@/assets/img/body-background.png')
    background-position: 50% 0
    background-color: #E9E9E5
    .footer-main
      .grid-box
        @apply grid grid-cols-1 gap-6
        @screen sm
          @apply grid-cols-2
        @screen lg
          @apply grid-cols-3
        .box::v-deep
          //@apply mb-8
          &:last-of-type
            @apply mb-0
          h3
            @apply uppercase mb-2
            font-size: 1.2rem
            color: $color-primary
            @screen sm
              @apply mb-4
          address, p
            @apply not-italic
            color: $color-secondary
            a:hover
              @apply underline
          a
            color: $color-secondary
            &:hover
              @apply underline
          p
            @apply mt-2
      &::v-deep
        .footer-menu
          ul li a
            color: $color-secondary
            &:hover
              @apply underline
  .copyright
    @apply bg-white text-center py-6 uppercase
    color: $color-primary
    border-top: 0.3em solid $color-primary
    @screen sm
      @apply text-right
</style>
